import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../styles';
import styled from 'styled-components';
import { hero_img } from '../../assets';


function Showcase() {
    return (
        <>
            <StyledShowcase>
                <div className="row align-items-center justify-content-center ">
                    <div className="col-md-6 pry-text">
                        <div className="col-md-8 mx-auto px-md-0 px-3">
                            <h3 className=" display-6 ">
                                Your distinctive world of business management
                            </h3>
                            <p className="">
                                Reni finance is a Business Management Suite created to provide financial solutions for small, medium and large-sized business enterprises.
                            </p>
                            <Link to="/register">
                                <Button light className="btn br-sm get-started-btn fw-bold">
                                    Get Started
                                </Button>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={hero_img} alt="Hero with Laptop" width="100%" />
                    </div>
                </div>
            </StyledShowcase>
        </>
    );
}

export default Showcase;


const StyledShowcase = styled.section`
    
  margin: 5rem 0;
  padding: 0;
  background-size: cover;
  /* height: 100vh; */
  width: 100%;
  overflow-x: hidden;

  h3,p {
  word-break: keep-all !important;
    
  }

.get-started-btn {
border: 1px solid rgba(0, 30, 136, 0.30);
box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  }

`;
